export const AUTH = {
  loginForm: 'login-form',
  emailInput: 'email-input',
  passwordInput: 'password-input',
  loginButton: 'login-button',
  registerButton: 'register-button',
  roleRestaurantButton: 'role-restaurant-button',
  roleSupplierButton: 'role-supplier-button',
  businessNameInput: 'business-name-input',
  cifInput: 'cif-input',
  phoneInput: 'phone-input'
};

export const RESTAURANT = {
  dashboard: 'restaurant-dashboard',
  sosButton: 'sos-button',
  tomorrowButton: 'tomorrow-button',
  weeklyButton: 'weekly-button',
  surplusTab: 'surplus-tab',
  auctionsTab: 'auctions-tab',
  matchesTab: 'matches-tab',
  createAuctionModal: 'create-auction-modal',
  productSelect: 'product-select',
  quantityInput: 'quantity-input',
  formatSelect: 'format-select',
  submitAuctionButton: 'submit-auction-button'
};

export const SUPPLIER = {
  dashboard: 'supplier-dashboard',
  auctionsFeed: 'auctions-feed',
  surplusForm: 'surplus-form',
  publishSurplusButton: 'publish-surplus-button',
  bidButton: 'bid-button',
  priceInput: 'price-input',
  submitBidButton: 'submit-bid-button'
};

export const MATCH = {
  confirmationDialog: 'match-confirmation-dialog',
  feeAmount: 'fee-amount',
  restaurantContact: 'restaurant-contact',
  supplierContact: 'supplier-contact',
  confirmButton: 'confirm-match-button'
};

export const HOME = {
  emergentLink: 'emergent-link'
};
